<template>
  <ul class="blanklist">
    <template v-if="isTags">
      <template v-for="tag in categories">
        <li v-if="getTag(tag, 'name')" :key="catKey(tag)">
          <nuxt-link :to="getTagLink(tag)">
            {{ getTag(tag, 'name') }}
          </nuxt-link>
        </li>
      </template>
    </template>
    <template v-else>
      <template v-for="cat in categories">
        <li :key="catKey(cat)" v-if="showCat(cat)">
          <nuxt-link :to="getCategoryLink(cat)">
            <span v-if="arrows" class="icon-arrow-right"></span>
            {{ getCategory(cat, 'name') }}
          </nuxt-link>
        </li>
      </template>
    </template>
  </ul>
</template>

<script>
import { useBlogStore } from '~/stores/blog';
import { useContext } from '@nuxtjs/composition-api';
export default {
  name: 'BlogCategoryList',
  props: {
    categories: {
      type: Array,
      required: true,
    },
    arrows: {
      type: Boolean,
      default: false,
    },
    isTags: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const blogStore = useBlogStore();
    const { localePath } = useContext();
    const getCategoryLink = (cat) => {
      return localePath('/blog?c=' + getCategory(cat, 'slug'));
    };
    const getCategory = (cat, field) => {
      const storeCategories = blogStore.getCategoryById(cat.id);
      if (cat.id) {
        return cat && field ? storeCategories?.[field] : false;
      }
      return cat && field ? blogStore.getCategoryById(cat)?.[field] : false;
    };

    const getTagLink = (tag) => {
      return decodeURIComponent(localePath('/blog/tag/' + getTag(tag, 'slug')));
    };

    const getTag = (tag, field) => {
      if (tag.id) {
        return blogStore.getTagById(tag.id) ? blogStore.getTagById(tag.id)[field] : false;
      }
      return blogStore.getTagById(tag) ? blogStore.getTagById(tag)[field] : false;
    };

    const showCat = (t) => {
      if (!props.arrows) {
        return true;
      }
      return t.count ? true : false;
    };

    const catKey = (t) => {
      return props.arrows || t?.id ? t.id : t;
    };

    return {
      getCategory,
      getCategoryLink,
      getTagLink,
      getTag,
      showCat,
      catKey,
    };
  },
};
</script>
